import { css } from "styled-components";
/** @class PropertyCardPhotoBodyMixin */

/** @method */

export var PropertyCardPhotoBodyMixin = /*#__PURE__*/css(["grid-column:1 / -1;grid-row:1 / -1;"]);